export default class LogicError extends Error {
  type = 'logic'
}
